import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ArrowLeftRight } from 'lucide-react';
import ConfirmationDialog from '~/components/Dialogs/ConfirmationDialog';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import {
    domainEventBus,
    RegistrationInvertRequestedEvent,
} from '~/domain/events';
import { useRegistrationState } from '~/hooks/registration/useRegistrationStore';

interface RegistrationInvertToolProps {
    isDisabled: boolean;
}

export default function RegistrationInvertTool({
    isDisabled,
}: RegistrationInvertToolProps) {
    const intl = useIntl();
    const registrationState = useRegistrationState();
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);

    const selectedSopUid = registrationState.selectedSopInstanceUid;
    const isApproved =
        registrationState.selectedRegistration?.isApproved ?? false;

    const handleConfirm = () => {
        if (selectedSopUid) {
            domainEventBus.publish(
                new RegistrationInvertRequestedEvent(selectedSopUid)
            );
        }
        setIsConfirmDialogOpen(false);
    };

    const handleClick = () => {
        setIsConfirmDialogOpen(true);
    };

    return (
        <>
            <ToolbarButton
                icon={<ArrowLeftRight />}
                tooltip={<FormattedMessage id="registration.invert" />}
                ariaLabel={intl.formatMessage({ id: 'registration.invert' })}
                disabled={isDisabled || !selectedSopUid || isApproved}
                onClick={handleClick}
            />

            <ConfirmationDialog
                open={isConfirmDialogOpen}
                title={
                    <FormattedMessage id="registration.invertConfirmTitle" />
                }
                message={
                    <FormattedMessage id="registration.invertConfirmMessage" />
                }
                onConfirm={handleConfirm}
                onCancel={() => setIsConfirmDialogOpen(false)}
                confirmText={<FormattedMessage id="registration.invert" />}
                cancelText={<FormattedMessage id="cancel" />}
            />
        </>
    );
}
